/* ============================================================
   Product Customizer Widget
   Config-driven full-screen configurator (Orange Whip style).

   Usage:
     ProductCustomizer.init({
       mount: document.body,          // where the overlay is appended
       trigger: '#customize-btn',     // selector or element that opens it
       config: {...},                 // see README for schema
       shopify: {                     // omit for demo mode
         variants: [...],             // product variants JSON
         cartUrl: '/cart/add.js',
         goToCartOnAdd: true
       },
       onAdd: function(payload) {}    // optional override for add-to-cart
     });

   Config schema (summary):
     {
       title: "MY PRODUCT",
       currencyFormat: "${amount}",     // {amount} replaced with price
       basePriceCents: 9999,            // demo mode only; Shopify uses variant price
       previewMode: "svg" | "layers",   // svg: recolor parts; layers: swap images
       previewSvg: "<svg>...</svg>",    // svg mode: parts use fill="var(--pcz-<groupId>)"
       groups: [
         {
           id: "grip", label: "Grip",
           type: "buttons" | "swatches",
           icon: "<svg.../>" or "https://..img.png",
           variantOption: true,          // maps to a Shopify variant option
           required: true,               // must pick before add-to-cart
           default: "blue",              // optional preselected option id
           options: [
             { id:"blue", label:"Blue", sublabel:"", swatch:"#2c4a8a",
               color:"#2c4a8a",            // svg mode tint
               layerImage:"grip-blue.png", // layers mode image
               variantValue:"Blue",        // exact Shopify option value (defaults to label)
               priceDeltaCents: 0 }
           ]
         }
       ]
     }
   ============================================================ */

(function (global) {
  'use strict';

  var svgParser = new DOMParser();

  // Parse an SVG string into a DOM node. Only ever used for icons that ship
  // with this widget or SVG supplied by the merchant's own theme config —
  // never for shopper-entered content.
  function parseSvg(svgString) {
    var doc = svgParser.parseFromString(svgString, 'image/svg+xml');
    return document.importNode(doc.documentElement, true);
  }

  var CHEVRON_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" class="pcz-group-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 6 15 12 9 18"/></svg>';
  var RESET_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg>';

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  }

  function formatMoney(cents, format) {
    var amount = (cents / 100).toFixed(2);
    if (amount.slice(-3) === '.00') amount = amount.slice(0, -3);
    return (format || '${amount}').replace('{amount}', amount);
  }

  function ProductCustomizer(opts) {
    this.opts = opts || {};
    this.config = opts.config;
    this.shopify = opts.shopify || null;
    this.state = { selections: {}, qty: 1 };
    this.allowedByCond = {}; // groupId -> array of allowed option ids (from conditions)
    this._build();
    this._bindTrigger();
    this._applyDefaults();
    this._render();
  }

  /* ---------- construction ---------- */

  ProductCustomizer.prototype._build = function () {
    var cfg = this.config;
    var self = this;

    var overlay = (this.overlay = el('div', 'pcz-overlay'));
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', cfg.title || 'Product customizer');

    var body = el('div', 'pcz-body');

    // Left preview pane
    var previewPane = el('div', 'pcz-preview-pane');
    var closeBtn = el('button', 'pcz-close', '×');
    closeBtn.type = 'button';
    closeBtn.setAttribute('aria-label', 'Close customizer');
    closeBtn.addEventListener('click', this.close.bind(this));

    this.previewEl = el('div', 'pcz-preview');
    if (cfg.previewMode === 'svg' && cfg.previewSvg) {
      this.previewEl.appendChild(parseSvg(cfg.previewSvg));
    } else {
      // layers mode: static base layers + one stacked <img> per group
      this.layerImgs = {};
      (cfg.baseLayers || []).forEach(function (b) {
        var img = el('img', 'pcz-layer');
        img.alt = '';
        img.src = b.image;
        if (b.z != null) img.style.zIndex = b.z;
        self.previewEl.appendChild(img);
      });
      (cfg.groups || []).forEach(function (g) {
        var hasLayers = (g.options || []).some(function (o) { return o.layerImage; });
        if (!hasLayers) return;
        var img = el('img', 'pcz-layer');
        img.alt = '';
        img.dataset.group = g.id;
        img.style.display = 'none';
        if (g.layerZ != null) img.style.zIndex = g.layerZ;
        self.layerImgs[g.id] = img;
        self.previewEl.appendChild(img);
      });
    }

    var resetBtn = el('button', 'pcz-reset');
    resetBtn.type = 'button';
    resetBtn.appendChild(parseSvg(RESET_SVG));
    resetBtn.appendChild(el('span', null, 'Reset'));
    resetBtn.addEventListener('click', this.reset.bind(this));

    previewPane.appendChild(closeBtn);
    previewPane.appendChild(this.previewEl);
    previewPane.appendChild(resetBtn);

    // Right rail
    var rail = el('div', 'pcz-rail');
    rail.appendChild(el('div', 'pcz-rail-header', cfg.title || 'Customize'));
    this.groupsEl = el('div', 'pcz-groups');
    rail.appendChild(this.groupsEl);
    this._buildGroups();

    body.appendChild(previewPane);
    body.appendChild(rail);

    // Footer
    var footer = el('div', 'pcz-footer');
    this.errorEl = el('span', 'pcz-error');
    this.priceEl = el('div', 'pcz-price');

    var qty = el('div', 'pcz-qty');
    var minus = el('button', null, '−');
    minus.type = 'button';
    var plus = el('button', null, '+');
    plus.type = 'button';
    this.qtyInput = el('input');
    this.qtyInput.type = 'number';
    this.qtyInput.min = '1';
    this.qtyInput.value = '1';
    this.qtyInput.setAttribute('aria-label', 'Quantity');
    minus.addEventListener('click', function () { self._setQty(self.state.qty - 1); });
    plus.addEventListener('click', function () { self._setQty(self.state.qty + 1); });
    this.qtyInput.addEventListener('change', function () {
      self._setQty(parseInt(self.qtyInput.value, 10) || 1);
    });
    qty.appendChild(minus);
    qty.appendChild(this.qtyInput);
    qty.appendChild(plus);

    this.addBtn = el('button', 'pcz-add', 'Add to Cart');
    this.addBtn.type = 'button';
    this.addBtn.addEventListener('click', this._addToCart.bind(this));

    footer.appendChild(this.errorEl);
    footer.appendChild(this.priceEl);
    footer.appendChild(qty);
    footer.appendChild(this.addBtn);

    overlay.appendChild(body);
    overlay.appendChild(footer);
    (this.opts.mount || document.body).appendChild(overlay);

    this._onKey = function (e) {
      if (e.key === 'Escape') self.close();
    };
  };

  ProductCustomizer.prototype._buildGroups = function () {
    var self = this;
    this.groupEls = {};
    (this.config.groups || []).forEach(function (g) {
      var card = el('div', 'pcz-group');
      card.dataset.group = g.id;

      var head = el('button', 'pcz-group-head');
      head.type = 'button';
      head.setAttribute('aria-expanded', 'false');

      if (g.icon) {
        if (/^\s*</.test(g.icon)) {
          var iconWrap = el('span', 'pcz-group-icon');
          iconWrap.appendChild(parseSvg(g.icon)); // merchant-config SVG only
          head.appendChild(iconWrap);
        } else {
          var iconImg = el('img', 'pcz-group-icon');
          iconImg.alt = '';
          iconImg.src = g.icon;
          head.appendChild(iconImg);
        }
      }
      head.appendChild(el('span', 'pcz-group-label', g.label));
      head.appendChild(el('span', 'pcz-group-value'));
      head.appendChild(parseSvg(CHEVRON_SVG));
      head.addEventListener('click', function () { self._toggleGroup(g.id); });

      var wrapClass = 'pcz-opts-buttons';
      if (g.type === 'swatches') wrapClass = 'pcz-opts-swatches';
      else if (g.type === 'dropdown') wrapClass = 'pcz-opts-dropdown';
      var optsWrap = el('div', 'pcz-group-options ' + wrapClass);

      if (g.type === 'dropdown') {
        var dd = el('select', 'pcz-select');
        dd.setAttribute('aria-label', g.label);
        if (!g.default) {
          var ph = el('option', null, 'Choose an option');
          ph.value = '';
          dd.appendChild(ph);
        }
        (g.options || []).forEach(function (o) {
          var label = o.label;
          if (o.priceDeltaCents) {
            label += ' (+' + formatMoney(o.priceDeltaCents, self.config.currencyFormat) + ')';
          }
          var opt = el('option', null, label);
          opt.value = o.id;
          // Same hook the buttons use, so conditional logic can disable it.
          opt.setAttribute('data-option', o.id);
          dd.appendChild(opt);
        });
        dd.addEventListener('change', function () {
          if (dd.value) self.select(g.id, dd.value);
        });
        optsWrap.appendChild(dd);
      }

      (g.type === 'dropdown' ? [] : g.options || []).forEach(function (o) {
        var btn;
        if (g.type === 'swatches') {
          btn = el('button', 'pcz-swatch');
          var tip = o.label;
          if (o.priceDeltaCents) {
            tip += ' (+' + formatMoney(o.priceDeltaCents, self.config.currencyFormat) + ')';
          }
          btn.setAttribute('data-label', tip);
          if (o.swatchImage) {
            var swImg = el('img');
            swImg.alt = '';
            swImg.src = o.swatchImage;
            btn.appendChild(swImg);
          } else {
            btn.style.background = o.swatch || o.color || '#ccc';
          }
        } else {
          btn = el('button', 'pcz-opt-btn', o.label);
          if (o.priceDeltaCents) {
            btn.appendChild(document.createTextNode(' '));
            btn.appendChild(
              el('small', null, '+' + formatMoney(o.priceDeltaCents, self.config.currencyFormat))
            );
          }
          if (o.sublabel) btn.appendChild(el('span', 'pcz-opt-sublabel', o.sublabel));
        }
        btn.type = 'button';
        btn.dataset.option = o.id;
        btn.setAttribute('aria-label', g.label + ': ' + o.label);
        btn.addEventListener('click', function () { self.select(g.id, o.id); });
        optsWrap.appendChild(btn);
      });

      card.appendChild(head);
      card.appendChild(optsWrap);
      self.groupsEl.appendChild(card);
      self.groupEls[g.id] = card;
    });
  };

  ProductCustomizer.prototype._bindTrigger = function () {
    var t = this.opts.trigger;
    if (!t) return;
    var node = typeof t === 'string' ? document.querySelector(t) : t;
    if (node) node.addEventListener('click', this.open.bind(this));
  };

  /* ---------- state ---------- */

  ProductCustomizer.prototype._applyDefaults = function () {
    var self = this;
    (this.config.groups || []).forEach(function (g) {
      if (g.default) self.state.selections[g.id] = g.default;
    });
  };

  ProductCustomizer.prototype.select = function (groupId, optionId) {
    this.state.selections[groupId] = optionId;
    this.errorEl.textContent = '';
    this._applyConditions(groupId);
    this._render();
    // Auto-advance: collapse the group just chosen and open the next one, so
    // the shopper can work straight down the list. Passing null closes them
    // all, which is what should happen after the final group.
    var groups = this.config.groups || [];
    for (var i = 0; i < groups.length; i++) {
      if (groups[i].id !== groupId) continue;
      var next = groups[i + 1];
      this._toggleGroup(next ? next.id : null, true);
      return;
    }
  };

  // Conditional logic: when a trigger group changes, conditions may force a
  // selection in another group and/or restrict its allowed options.
  //   conditions: [{ when: {group, option},
  //                  then: {group, select: 'id', allow: ['id', ...]} }]
  ProductCustomizer.prototype._applyConditions = function (changedGroup) {
    var self = this;
    (this.config.conditions || []).forEach(function (c) {
      if (!c.when || !c.then || c.when.group !== changedGroup) return;
      var t = c.then;
      if (self.state.selections[c.when.group] === c.when.option) {
        if (t.allow) self.allowedByCond[t.group] = t.allow;
        if (t.select) self.state.selections[t.group] = t.select;
      } else if (t.allow && self.allowedByCond[t.group] === t.allow) {
        delete self.allowedByCond[t.group];
      }
    });
  };

  ProductCustomizer.prototype.reset = function () {
    this.state.selections = {};
    this.allowedByCond = {};
    this.state.qty = 1;
    this.qtyInput.value = '1';
    this._applyDefaults();
    this.errorEl.textContent = '';
    this._render();
  };

  ProductCustomizer.prototype._setQty = function (q) {
    this.state.qty = Math.max(1, q | 0);
    this.qtyInput.value = String(this.state.qty);
  };

  ProductCustomizer.prototype._toggleGroup = function (groupId, forceOpen) {
    var self = this;
    Object.keys(this.groupEls).forEach(function (id) {
      var open =
        id === groupId &&
        (forceOpen || !self.groupEls[id].classList.contains('pcz-expanded'));
      self.groupEls[id].classList.toggle('pcz-expanded', open);
      self.groupEls[id]
        .querySelector('.pcz-group-head')
        .setAttribute('aria-expanded', String(open));
    });
  };

  /* ---------- rendering ---------- */

  ProductCustomizer.prototype._findOption = function (g, optionId) {
    for (var i = 0; i < (g.options || []).length; i++) {
      if (g.options[i].id === optionId) return g.options[i];
    }
    return null;
  };

  ProductCustomizer.prototype._render = function () {
    var self = this;
    var cfg = this.config;

    (cfg.groups || []).forEach(function (g) {
      var card = self.groupEls[g.id];
      var sel = self.state.selections[g.id];
      var opt = sel ? self._findOption(g, sel) : null;

      var allowed = self.allowedByCond[g.id] || null;
      card.querySelectorAll('[data-option]').forEach(function (b) {
        b.classList.toggle('pcz-selected', b.dataset.option === sel);
        var dis = !!(allowed && allowed.indexOf(b.dataset.option) === -1);
        b.classList.toggle('pcz-disabled', dis);
        b.disabled = dis;
      });
      var dropdown = card.querySelector('.pcz-select');
      if (dropdown && dropdown.value !== (sel || '')) dropdown.value = sel || '';
      card.querySelector('.pcz-group-value').textContent = opt ? opt.label : '';

      if (cfg.previewMode === 'svg') {
        if (opt && opt.color) self.previewEl.style.setProperty('--pcz-' + g.id, opt.color);
      } else if (self.layerImgs && self.layerImgs[g.id]) {
        var img = self.layerImgs[g.id];
        if (opt && opt.layerImage) {
          if (img.getAttribute('src') !== opt.layerImage) img.src = opt.layerImage;
          img.style.display = '';
        } else {
          // Option with no layer image (e.g. a color baked into the base
          // photo) or nothing selected yet: hide this layer entirely.
          img.style.display = 'none';
        }
      }
    });

    // When variants differ in price and no size is chosen yet, the total falls
    // back to the cheapest variant — label it "From" so it can't read as the
    // price of whatever the shopper eventually picks.
    var price = formatMoney(this._totalCents(), cfg.currencyFormat);
    if (this.shopify && !this._resolveVariant() && this._hasPriceSpread()) {
      price = (cfg.fromLabel || 'From ') + price;
    }
    this.priceEl.textContent = price;
  };

  ProductCustomizer.prototype._hasPriceSpread = function () {
    var vs = (this.shopify && this.shopify.variants) || [];
    for (var i = 1; i < vs.length; i++) {
      if (vs[i].price !== vs[0].price) return true;
    }
    return false;
  };

  ProductCustomizer.prototype._totalCents = function () {
    var base;
    if (this.shopify) {
      var v = this._resolveVariant();
      base = v ? v.price : this._minVariantPrice();
    } else {
      base = this.config.basePriceCents || 0;
    }
    var self = this;
    (this.config.groups || []).forEach(function (g) {
      var opt = self._findOption(g, self.state.selections[g.id]);
      if (opt && opt.priceDeltaCents) base += opt.priceDeltaCents;
    });
    return base;
  };

  ProductCustomizer.prototype._minVariantPrice = function () {
    var vs = (this.shopify && this.shopify.variants) || [];
    var min = Infinity;
    vs.forEach(function (v) { if (v.price < min) min = v.price; });
    return min === Infinity ? 0 : min;
  };

  /* ---------- Shopify integration ---------- */

  ProductCustomizer.prototype._resolveVariant = function () {
    if (!this.shopify || !this.shopify.variants) return null;
    var self = this;
    var wanted = [];
    (this.config.groups || []).forEach(function (g) {
      if (!g.variantOption) return;
      var opt = self._findOption(g, self.state.selections[g.id]);
      if (opt) wanted.push(opt.variantValue || opt.label);
    });
    if (!wanted.length) return null;
    var match = null;
    var soldOut = null;
    // requireSku lets a customized build be sold as a different SKU than the
    // stock product whose page the shopper is on (e.g. a made-to-order SKU).
    var requireSku = this.shopify.requireSku;
    this.shopify.variants.forEach(function (v) {
      if (requireSku && v.sku !== requireSku) return;
      var values = [v.option1, v.option2, v.option3].filter(Boolean);
      // Every mapped option must match AND the variant must have no unmapped
      // options left over, so a product that gains a second option can't
      // silently resolve to an arbitrary variant.
      var ok = values.length === wanted.length &&
        wanted.every(function (w) { return values.indexOf(w) !== -1; });
      if (!ok) return;
      // Prefer a purchasable variant; keep a sold-out one only so the shopper
      // gets a real "sold out" message instead of a silent mismatch.
      if (v.available === false) {
        if (!soldOut) soldOut = v;
      } else if (!match) {
        match = v;
      }
    });
    return match || soldOut;
  };

  ProductCustomizer.prototype._validate = function () {
    var groups = this.config.groups || [];
    for (var i = 0; i < groups.length; i++) {
      var g = groups[i];
      if ((g.required || g.variantOption) && !this.state.selections[g.id]) {
        this.errorEl.textContent = 'Please choose a ' + g.label + '.';
        this._toggleGroup(g.id, true);
        return false;
      }
    }
    return true;
  };

  ProductCustomizer.prototype._addToCart = function () {
    if (!this._validate()) return;
    var self = this;
    var cfg = this.config;

    // Non-variant selections become cart line item properties
    var properties = {};
    (cfg.groups || []).forEach(function (g) {
      if (g.variantOption) return;
      var opt = self._findOption(g, self.state.selections[g.id]);
      if (opt) properties[g.label] = opt.label;
    });

    var payload = {
      selections: this.state.selections,
      properties: properties,
      quantity: this.state.qty,
      totalCents: this._totalCents()
    };

    if (typeof this.opts.onAdd === 'function') {
      this.opts.onAdd(payload, this);
      return;
    }

    if (this.shopify) {
      var variant = this._resolveVariant();
      if (!variant) {
        this.errorEl.textContent = 'That combination is unavailable.';
        return;
      }
      if (variant.available === false) {
        this.errorEl.textContent = 'That size is sold out.';
        return;
      }
      this.addBtn.disabled = true;
      this.addBtn.textContent = 'Adding…';
      fetch(this.shopify.cartUrl || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variant.id,
          quantity: this.state.qty,
          properties: properties
        })
      })
        .then(function (r) {
          if (!r.ok) {
            return r.json().then(function (j) {
              throw new Error(j.description || 'Could not add to cart');
            });
          }
          return r.json();
        })
        .then(function () {
          self.addBtn.textContent = 'Added ✓';
          document.dispatchEvent(new CustomEvent('pcz:added', { detail: payload }));
          if (self.shopify.goToCartOnAdd !== false) {
            window.location.href = '/cart';
            return;
          }
          setTimeout(function () {
            self.addBtn.disabled = false;
            self.addBtn.textContent = 'Add to Cart';
            self.close();
            // We post straight to Shopify's cart API, so the theme has no idea
            // anything changed — its header count and drawer would still show
            // the old cart. Tell it to rebuild, then reveal the cart.
            self._notifyTheme();
          }, 700);
        })
        .catch(function (err) {
          self.errorEl.textContent = err.message;
          self.addBtn.disabled = false;
          self.addBtn.textContent = 'Add to Cart';
        });
    } else {
      // Demo mode
      this.addBtn.textContent = 'Added ✓';
      var btn = this.addBtn;
      setTimeout(function () { btn.textContent = 'Add to Cart'; }, 1200);
      document.dispatchEvent(new CustomEvent('pcz:added', { detail: payload }));
    }
  };

  // Nudge the host theme to refresh its cart UI after we add a line item.
  // Defaults cover the common Shopify theme conventions; a theme with
  // different event names can override them via shopify.cartEvents.
  ProductCustomizer.prototype._notifyTheme = function () {
    var cfg = this.shopify || {};
    var refresh = cfg.cartEvents || ['cart:build', 'cart:refresh', 'cart:updated'];
    refresh.forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
    });
    // cartOpenEvent: null disables opening the drawer entirely.
    if (cfg.cartOpenEvent !== null) {
      document.dispatchEvent(
        new CustomEvent(cfg.cartOpenEvent || 'cart:open', { bubbles: true })
      );
    }
  };

  /* ---------- open / close ---------- */

  // Warm the browser cache for every layer image so color swaps are instant.
  ProductCustomizer.prototype._preloadLayers = function () {
    if (this._preloaded || this.config.previewMode === 'svg') return;
    this._preloaded = true;
    (this.config.groups || []).forEach(function (g) {
      (g.options || []).forEach(function (o) {
        if (o.layerImage) {
          var i = new Image();
          i.src = o.layerImage;
        }
      });
    });
  };

  ProductCustomizer.prototype.open = function () {
    this._preloadLayers();
    this.overlay.classList.add('pcz-open');
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', this._onKey);
    var first = (this.config.groups || [])[0];
    if (first && !this.expandedOnce) {
      this._toggleGroup(first.id, true);
      this.expandedOnce = true;
    }
  };

  ProductCustomizer.prototype.close = function () {
    this.overlay.classList.remove('pcz-open');
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', this._onKey);
  };

  /* ---------- public API ---------- */

  global.ProductCustomizer = {
    init: function (opts) { return new ProductCustomizer(opts); }
  };
})(window);
